import { apiClient } from "../config";

async function bulkInvitation(payload: any) {
  const res = await apiClient.post(`/admin/users/bulk-invites`, payload);
  return res.data;
}

export default bulkInvitation;
